import fetch from "api/utils/enhancedFetch";
import { getProxycadorHost } from "environment";

export const getIntercomUserHash = (): Promise<{ userHash: string }> =>
  fetch(
    `${getProxycadorHost()}/proxycador/api/public/v1/intercom/identity/user-hash`
  ).then((resp) => resp.json());
